import type { FC, ReactNode } from 'react'

import TestimonialBase, * as Testimonial from '@segment/matcha/recipes/Testimonial'

import type { SignUpViewProps } from 'views/SignUp/SignUp'

interface TestimonialPlaybookProps {
  data: SignUpViewProps[`playbook`][`testimonial`]
  testimonialLogo: ReactNode
}
const TestimonialPlaybook: FC<TestimonialPlaybookProps> = ({ data, testimonialLogo }) => {
  const { text, author, data: tData } = data

  return (
    <TestimonialBase variant="base">
      <Testimonial.Base height="auto">
        <Testimonial.BaseContentSlot>
          <Testimonial.BaseLogo>{testimonialLogo}</Testimonial.BaseLogo>
          <Testimonial.BaseText>{text}</Testimonial.BaseText>
        </Testimonial.BaseContentSlot>
        <Testimonial.BaseAuthorSlot>
          <Testimonial.AuthorInfo>
            <Testimonial.AuthorName>{author.name}</Testimonial.AuthorName>
            <Testimonial.AuthorPosition>{author.title}</Testimonial.AuthorPosition>
          </Testimonial.AuthorInfo>
        </Testimonial.BaseAuthorSlot>
      </Testimonial.Base>
      <Testimonial.Extended>
        <Testimonial.ExtendedTextSlot>
          <Testimonial.ExtendedHeader>
            {tData.rate}
            <Testimonial.ExtendedHeaderSup>{tData.sign}</Testimonial.ExtendedHeaderSup>
          </Testimonial.ExtendedHeader>
          <Testimonial.ExtendedText>{tData.text}</Testimonial.ExtendedText>
        </Testimonial.ExtendedTextSlot>
        <Testimonial.ExtendedButtonSlot>
          <Testimonial.ExtendedStoryLink>
            <Testimonial.ExtendedButton href={tData.link} text="Read their story" />
          </Testimonial.ExtendedStoryLink>
        </Testimonial.ExtendedButtonSlot>
      </Testimonial.Extended>
    </TestimonialBase>
  )
}

export default TestimonialPlaybook
